import { render, staticRenderFns } from "./search.vue?vue&type=template&id=363c87d4"
import script from "./search.ts?vue&type=script&lang=ts&external"
export * from "./search.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports